class Search {
	isOpen = false;
	stateClasses = {
		open: 'search--open',
	};

	constructor($el) {
		this.$el = $el;
		this.$trigger = $el.find('[data-search="trigger"]');
		this.$input = $el.find('[data-search="input"]');

		this.init();
	}

	init = () => {
		this.bindEvents();
	};

	bindEvents = () => {
		this.$trigger.on('click', this.toggle);
	};

	open = () => {
		this.$el.addClass(this.stateClasses.open);
		this.$input.focus();
		this.isOpen = true;
		$(document).on('keyup', this.handleEscape);
		$(document).on('click', this.handleOutsideClick);
	};

	close = () => {
		this.$el.removeClass(this.stateClasses.open);
		this.$input.blur();
		this.isOpen = false;
		$(document).off('keyup', this.handleEscape);
		$(document).off('click', this.handleOutsideClick);
	};

	toggle = () => {
		if (!this.isOpen) {
			this.open();
		} else {
			if (this.$input.val() === '') {
				this.close();
			} else {
				this.$el.submit();
			}
		}
	};

	handleEscape = e => {
		if (e.keyCode === 27) {
			this.close();
		}
	};

	handleOutsideClick = e => {
		if (this.isOpen && !$(e.target).closest(this.$el).length) {
			this.close();
		}
	};
}

export default Search;
